import 'adsinterceptor'
import { WorldReadyProvider } from '@paypalcorp/pp-react-worldready'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'
import { Router } from '@reach/router'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './app'
import { setupStore } from './store'
import { PreloadOptions } from './store/preload'
import serverData from './utils/server-data'

const preloadOptions: PreloadOptions = {
  pool: serverData.external?.pool,
}
const store = setupStore({ preloadOptions })

let root = document.getElementById('root')

if (!root) {
  root = document.createElement('div')
  document.body.appendChild(root)
}

ReactDOM.render(
  <WorldReadyContextProvider locale={serverData.locality.locale}>
    <WorldReadyProvider>
      <Provider store={store}>
        <Router basepath={serverData.requestURI}>
          {/*@ts-ignore : Not sure how to add a type for `path` */}
          <App path="*" />
        </Router>
      </Provider>
    </WorldReadyProvider>
  </WorldReadyContextProvider>,
  root,
)
